import React, { Component } from 'react'


import Header from './Header';
import Footer from './Footer';
import Board from './Board';
import Result from './Result';



class Home extends Component {

  constructor(props){
    super(props)
    this.state = {
        currentSlide:1,
        previousSlide:[],
        isResult:false
    }
  }

  componentWillMount() {
    debugger
    //this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave)
    //let {history, confirm, location, document} = window;
    //let {location} = 
    // debugger
    //if (history && history.pushState) {
      // addEventListener('load', function() {
      //     history.pushState(null, null, null); // creates new history entry with same URL
      //     addEventListener('popstate', function() {
      //         var stayOnPage = confirm("Are you sure you want to leave Rehabmart's Virtual Dizzy Clinic?");
      //         if (!stayOnPage) {
      //             history.back() 
      //         } else {
      //             history.pushState(null, null, null);
      //         }
      //     });    
      // });

      // $(function(){
      //   history.pushState(null, document.title, location.href); // creates new history entry with same URL
      //   $(window).on('popstate', function() {
      //     var stayOnPage = confirm("Are you sure you want to leave Rehabmart's Virtual Dizzy Clinic?");
      //     debugger
      //             if (stayOnPage) {
      //                 history.back() 
      //             } 
      //             // else{
      //             //   history.pushState(null, document.title, location.href);
      //             // }
      //   })
      // })
      
  //}
  }

  routerWillLeave(nextLocation) {
    // return false to prevent a transition w/o prompting the user,
    // or return a string to allow the user to decide:
    // return `null` or nothing to let other hooks to be executed
    //
    // NOTE: if you return true, other hooks will not be executed!
    debugger
    if (!this.state.isSaved)
      return 'Your work is not saved! Are you sure you want to leave?'
  }
  
  

  onClick = (cs,res) => {

    let {previousSlide,currentSlide,isResult} = this.state;

    if(isResult){
      previousSlide= [];
    }
    else{
      previousSlide.push({currentSlide,isResult});
    }
    this.setState({currentSlide:cs, isResult:res,previousSlide})
  }

  onBack = () => {
    
    const {previousSlide} = this.state;
    const back = previousSlide.pop();
    this.setState({currentSlide: back.currentSlide, isResult : back.isResult,previousSlide})
  }


  render() {
    const {isResult,currentSlide} = this.state;

    return (
      <div>
        

          <Header isResult={isResult}/>
          
          { !isResult && <Board onClick={this.onClick} slide={currentSlide} onBack={this.onBack} />}
          { isResult && <Result onClick={this.onClick}  slide={currentSlide} onBack={this.onBack}  />}
          <Footer/>
      </div>
    )
  }
}

export default Home;

